import {
  getCustomerDetail,
  updateCustomers,
  removeCustomerFromTurn,
  findAndAssignCustomer,
} from "../../helpers/fetching";

export default {
  state: {
    customerData: false,
    loading: false,
    error: null,
  },
  mutations: {
    clearError(state) {
      state.error = null;
    },
    setCustomerLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setCustomerResponse(state, data) {
      state.response = data;
    },
    setCustomer(state, data) {
      state.customerData = data;
      state.loading = false;
      state.error = null;
    },
    setResetCustomerData(state) {
      state.customerData = [];
      state.loading = false;
      state.error = null;
    },
    setCustomerError(state, data) {
      state.loading = false;
      state.error = data;
    },
  },
  actions: {
    gluedChange({ commit }, value) {
      commit("clearError");
      commit("setLoading", true);
      commit("setCustomer", value);
    },
    fetchCustomerDetails({ commit }, value) {
      commit("setCustomerLoading", true);
      getCustomerDetail(value)
        .then((response) => {
          commit("setCustomer", response);
          commit("setCustomerLoading", false);
        })
        .catch((error) => {
          console.error(error);
          commit("setCustomerError", error);
        });
    },
    sendUpdateCustomers({ commit }, value) {
      return new Promise((resolve) => {
        commit("setCustomerLoading", true);
        updateCustomers(value)
          .then((response) => {
            commit("setCustomerResponse", response);
            commit("setCustomerLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setCustomerError", error);
            resolve();
          });
      });
    },
    sendRemoveCustomerFromTurn({ commit }, value) {
      return new Promise((resolve) => {
        commit("setCustomerLoading", true);
        removeCustomerFromTurn(value)
          .then((response) => {
            commit("setCustomerResponse", response);
            commit("setCustomerLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setCustomerError", error);
            resolve();
          });
      });
    },
    sendFindAndAssignCustomer({ commit }, value) {
      return new Promise((resolve) => {
        commit("setCustomerLoading", true);
        findAndAssignCustomer(value)
          .then((response) => {
            commit("setCustomerResponse", response);
            commit("setCustomerLoading", false);
            resolve();
          })
          .catch((error) => {
            console.error(error);
            commit("setCustomerError", error);
            resolve();
          });
      });
    },
    resetCustomerData({ commit }) {
      commit("setResetCustomerData");
    },
  },
};
